import { render, staticRenderFns } from "./ClientWorkRequestEdit.vue?vue&type=template&id=27221143&"
import script from "./ClientWorkRequestEdit.vue?vue&type=script&lang=ts&"
export * from "./ClientWorkRequestEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports